// Hide-on-scroll nav: slide away scrolling down, return on scroll-up.
(function () {
  var nav = document.getElementById("nav");
  if (!nav) return;
  var lastY = 0;
  var hidden = false;
  window.addEventListener(
    "scroll",
    function () {
      var y = Math.max(window.scrollY, 0);
      if (y > lastY && y > nav.offsetHeight * 2 && !hidden) {
        nav.style.transform = "translateY(-110%)";
        hidden = true;
      } else if (y < lastY && hidden) {
        nav.style.transform = "translateY(0)";
        hidden = false;
      }
      lastY = y;
    },
    { passive: true }
  );
})();

// Scroll reveal on the main blocks.
(function () {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var targets = document.querySelectorAll(
    ".sn-intent, .sn-mcard, .sn-sidecard, .sn-overlaycard, .sn-badges-row span, " +
    ".sn-problem-item, .sn-problem-video, .sn-vstep, .sn-founder-media figure, .sn-progress-grid figure, " +
    ".sn-chapter-media, .sn-chapter-copy"
  );
  targets.forEach(function (el) {
    el.classList.add("sn-reveal");
  });
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    },
    { rootMargin: "0px 0px -8% 0px" }
  );
  targets.forEach(function (el) {
    io.observe(el);
  });
})();

// Resume autoplay videos when they scroll into view (offscreen-autoplay throttle fix).
(function () {
  var vids = document.querySelectorAll("video[autoplay]");
  if (!vids.length || !("IntersectionObserver" in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else { v.pause(); }
    });
  }, { threshold: 0.25 });
  vids.forEach(function (v) { io.observe(v); });
})();

// Generic rail arrows: any [data-rail-wrap] gets prev/next buttons scoped to
// its own scroller (fixes the single-querySelector binding from before).
(function () {
  document.querySelectorAll("[data-rail-wrap]").forEach(function (wrap) {
    var rail = wrap.querySelector("[data-rail]");
    if (!rail) return;
    var prev = wrap.querySelector("[data-prev]");
    var next = wrap.querySelector("[data-next]");
    var step = Math.round(rail.clientWidth * 0.7) || 330;
    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step, behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step, behavior: "smooth" }); });
  });
})();

// Founder storyline: spine fills with scroll, chapter dots light as they pass.
(function () {
  var wrap = document.querySelector(".sn-storyline-inner");
  var fill = document.querySelector(".sn-spine-fill");
  if (!wrap || !fill) return;
  var chapters = wrap.querySelectorAll(".sn-chapter");
  function update() {
    var r = wrap.getBoundingClientRect();
    var mid = window.innerHeight * 0.55;
    var p = (mid - r.top) / r.height;
    p = Math.max(0, Math.min(1, p));
    fill.style.height = (p * 100) + "%";
    chapters.forEach(function (ch) {
      var cr = ch.getBoundingClientRect();
      ch.classList.toggle("lit", cr.top + cr.height * 0.35 < mid);
    });
  }
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", update);
  update();
})();

// Video-stories rail: unmute one card at a time.
(function () {
  var cards = document.querySelectorAll(".sn-vs-card");
  if (!cards.length) return;
  cards.forEach(function (card) {
    var btn = card.querySelector(".sn-vs-unmute");
    var vid = card.querySelector("video");
    if (!btn || !vid) return;
    btn.addEventListener("click", function () {
      var unmuting = vid.muted;
      document.querySelectorAll(".sn-vs-card video").forEach(function (v) {
        v.muted = true;
        var b = v.closest(".sn-vs-card").querySelector(".sn-vs-unmute");
        if (b) b.textContent = "Unmute";
      });
      if (unmuting) {
        vid.muted = false;
        btn.textContent = "Mute";
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  });
})();

// Rail arrow end-states + clean initial scroll position.
(function () {
  document.querySelectorAll("[data-rail-wrap]").forEach(function (wrap) {
    var rail = wrap.querySelector("[data-rail]");
    if (!rail) return;
    rail.scrollLeft = 0;
    var prev = wrap.querySelector("[data-prev]");
    var next = wrap.querySelector("[data-next]");
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    rail.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  });
  // the product journey rail (.sn-rail) is not in a data-rail-wrap; reset it too
  document.querySelectorAll(".sn-rail").forEach(function (r) { r.scrollLeft = 0; });
})();

// Symptom tabs (data-tab -> #tab-<id>)
(function(){
  document.querySelectorAll('.sn-tabs').forEach(function(wrap){
    var btns=wrap.querySelectorAll('.sn-tabbtn');
    btns.forEach(function(btn){
      btn.addEventListener('click', function(){
        btns.forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        wrap.querySelectorAll('.sn-tabpanel').forEach(function(p){p.classList.remove('active');});
        var panel=wrap.querySelector('#tab-'+btn.dataset.tab);
        if(panel) panel.classList.add('active');
      });
    });
  });
})();

// Lazy video loader: load source + play only when near viewport (600px head-start), pause when out.
(function(){
  var lazy=document.querySelectorAll('.sn-lazyvid');
  if(!lazy.length||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      var v=e.target;
      if(e.isIntersecting){
        if(!v.dataset.loaded){
          var s=v.querySelector('source[data-src]');
          if(s){ s.src=s.getAttribute('data-src'); v.load(); v.dataset.loaded='1'; }
        }
        var pr=v.play(); if(pr&&pr.catch) pr.catch(function(){});
      } else if(v.dataset.loaded){ v.pause(); }
    });
  },{rootMargin:'600px 0px'});
  lazy.forEach(function(v){ io.observe(v); });
})();

// Count-up stats: every number in a stats section shares ONE clock and animates
// 0 -> target over the SAME duration, so they all finish together (large numbers race,
// small ones crawl). Grouped per .sn-stats section; fires when that section enters view.
(function(){
  var all=[].slice.call(document.querySelectorAll('.sn-stat-num'));
  if(!all.length) return;
  if(!('IntersectionObserver' in window)) return; // static real number already shown
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR=1500;
  var groups=[];
  all.forEach(function(el){
    var sec=el.closest('.sn-stats')||el.closest('.shopify-section')||document.body;
    var g=groups.filter(function(x){return x.sec===sec;})[0];
    if(!g){ g={sec:sec, els:[]}; groups.push(g); }
    g.els.push(el);
  });
  function run(els){
    var items=els.map(function(el){ return {el:el, to:parseFloat(el.dataset.count), dec:parseInt(el.dataset.dec||'0',10)}; });
    if(reduced){ items.forEach(function(x){ if(!isNaN(x.to)) x.el.textContent=x.to.toFixed(x.dec); }); return; }
    var start=null;
    function tick(t){
      if(start===null) start=t;
      var p=Math.min(1,(t-start)/DUR);
      var eased=1-Math.pow(1-p,3); // ease-out; every number reaches p=1 together
      items.forEach(function(x){ if(!isNaN(x.to)) x.el.textContent=(x.to*eased).toFixed(x.dec); });
      if(p<1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if(!e.isIntersecting) return;
      io.unobserve(e.target);
      var g=groups.filter(function(x){return x.sec===e.target;})[0];
      if(g) run(g.els);
    });
  },{threshold:0.3});
  groups.forEach(function(g){ io.observe(g.sec); });
})();

// Perf: continuous animations (marquees, ken-burns zooms, ticker) keep running even when
// scrolled off-screen, which burns CPU/GPU and causes scroll jank. Pause them when not visible.
(function(){
  var sel='.sn-press-track,.sn-symticker-row,.sn-motion > img,.sn-pagehero-media img,.horizontal-ticker__container';
  var els=[].slice.call(document.querySelectorAll(sel));
  if(!els.length||!('IntersectionObserver' in window)) return;
  els.forEach(function(el){ el.style.animationPlayState='paused'; });
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      e.target.style.animationPlayState = e.isIntersecting ? 'running' : 'paused';
    });
  },{rootMargin:'200px 0px'});
  els.forEach(function(el){ io.observe(el); });
})();

// Per-section fonts: sections carry their @font-face CSS in data-fontface (a <style> tag inside a
// section breaks rendering in the product template, so we inject it into <head> instead).
(function(){
  var nodes=document.querySelectorAll('[data-fontface],[data-sn-css]');
  if(!nodes.length) return;
  var seen={}, css='';
  [].forEach.call(nodes,function(n){
    var f=(n.getAttribute('data-fontface')||'')+(n.getAttribute('data-sn-css')||'');
    if(f && !seen[f]){ seen[f]=1; css+=f; }
  });
  if(!css) return;
  var st=document.createElement('style');
  st.id='sn-fontface-inject';
  st.textContent=css;
  document.head.appendChild(st);
})();
